import React from 'react';
import { ShieldCheck, BrainCircuit } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-black py-20 px-4 relative overflow-hidden pt-[20px] pb-[20px]" data-id="element-107">
      {/* Orange accent blob */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-96 h-96 bg-orange-600/10 blur-[80px] rounded-full pointer-events-none" data-id="element-108" />

      <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-109">
        <div className="inline-flex items-center gap-2 text-orange-500 font-bold tracking-wider uppercase text-sm mb-4 justify-center" data-id="element-110">
          <BrainCircuit className="w-5 h-5" data-id="element-111" />
          <span data-id="element-112">The GSI Method</span>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-113">
          Why "Letting them figure it out" is a{' '}
          <span className="text-orange-500" data-id="element-114">Recipe for Disaster</span>.
        </h2>

        <p className="text-xl text-gray-300 mb-8 leading-relaxed max-w-3xl mx-auto" data-id="element-115">
          Most owners wait for the fighting to stop and hope for the best. This
          only deepens the conflict.
        </p>

        <div className="bg-gray-900/50 border border-orange-500/20 rounded-2xl p-8 max-w-3xl mx-auto relative overflow-hidden" data-id="element-116">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent opacity-50" data-id="element-117"></div>
          <p className="text-lg text-gray-200" data-id="element-118">
            The Feline Harmony Blueprint™ uses . We hack their sense of smell
            to create a 'Shared Identity' to reset their relationship from zero.
          </p>
        </div>
      </div>
    </section>;
}